import { FC, SVGProps } from 'react';
import { AttachmentCategory } from './attachmentUtils';

export const PaperclipIcon: FC<SVGProps<SVGSVGElement>> = ({ className, ...props }) => (
	<svg
		width="18"
		height="18"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		className={className}
		{...props}
	>
		<path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
	</svg>
);

export const DownloadActionIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		{...props}
	>
		<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
		<polyline points="7 10 12 15 17 10" />
		<line x1="12" y1="15" x2="12" y2="3" />
	</svg>
);

export const RemoveActionIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg
		width="14"
		height="14"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2.2"
		strokeLinecap="round"
		strokeLinejoin="round"
		{...props}
	>
		<line x1="18" y1="6" x2="6" y2="18" />
		<line x1="6" y1="6" x2="18" y2="18" />
	</svg>
);

export const UploadCloudIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		{...props}
	>
		<path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" />
		<path d="M12 12v9" />
		<path d="m16 16-4-4-4 4" />
	</svg>
);

export const PdfFileIcon: FC<SVGProps<SVGSVGElement>> = ({ className, ...props }) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className} {...props}>
		<rect width="24" height="24" rx="6" fill="#FEE4E2" />
		<path
			d="M6.5 5.5H13L17.5 10V18.5C17.5 19.0523 17.0523 19.5 16.5 19.5H7.5C6.94772 19.5 6.5 19.0523 6.5 18.5V5.5Z"
			fill="#D92D20"
		/>
		<path d="M13 5.5V10H17.5" fill="#F04438" />
		<text
			x="12"
			y="16"
			textAnchor="middle"
			fill="#FFFFFF"
			fontSize="4.75"
			fontWeight="800"
			fontFamily="-apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', Roboto, sans-serif"
			letterSpacing="-0.15"
		>
			PDF
		</text>
	</svg>
);

export const WordFileIcon: FC<SVGProps<SVGSVGElement>> = ({ className, ...props }) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className} {...props}>
		<rect width="24" height="24" rx="6" fill="#D1E9FF" />
		<path
			d="M6.5 5.5H13L17.5 10V18.5C17.5 19.0523 17.0523 19.5 16.5 19.5H7.5C6.94772 19.5 6.5 19.0523 6.5 18.5V5.5Z"
			fill="#1570EF"
		/>
		<path d="M13 5.5V10H17.5" fill="#2E90FA" />
		<text
			x="12"
			y="16"
			textAnchor="middle"
			fill="#FFFFFF"
			fontSize="4.75"
			fontWeight="800"
			fontFamily="-apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', Roboto, sans-serif"
			letterSpacing="-0.15"
		>
			DOC
		</text>
	</svg>
);

export const ExcelFileIcon: FC<SVGProps<SVGSVGElement>> = ({ className, ...props }) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className} {...props}>
		<rect width="24" height="24" rx="6" fill="#D1FADF" />
		<path
			d="M6.5 5.5H13L17.5 10V18.5C17.5 19.0523 17.0523 19.5 16.5 19.5H7.5C6.94772 19.5 6.5 19.0523 6.5 18.5V5.5Z"
			fill="#039855"
		/>
		<path d="M13 5.5V10H17.5" fill="#12B76A" />
		<text
			x="12"
			y="16"
			textAnchor="middle"
			fill="#FFFFFF"
			fontSize="4.75"
			fontWeight="800"
			fontFamily="-apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', Roboto, sans-serif"
			letterSpacing="-0.15"
		>
			XLS
		</text>
	</svg>
);

export const ImageFileIcon: FC<SVGProps<SVGSVGElement>> = ({ className, ...props }) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className} {...props}>
		<rect width="24" height="24" rx="6" fill="#EBE9FE" />
		<path
			d="M7 6H17C17.5523 6 18 6.44772 18 7V17C18 17.5523 17.5523 18 17 18H7C6.44772 18 6 17.5523 6 17V7C6 6.44772 6.44772 6 7 6Z"
			fill="#7A5AF8"
		/>
		<circle cx="10" cy="10" r="1.5" fill="#FFFFFF" />
		<path
			d="M6 16L9.5 12.5L13.5 16.5L15.5 14.5L18 17V17C18 17.5523 17.5523 18 17 18H7C6.44772 18 6 17.5523 6 17V16Z"
			fill="#BDB4FE"
		/>
	</svg>
);

export const VideoFileIcon: FC<SVGProps<SVGSVGElement>> = ({ className, ...props }) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className} {...props}>
		<rect width="24" height="24" rx="6" fill="#FCE7F6" />
		<path
			d="M6 7C6 6.44772 6.44772 6 7 6H14C14.5523 6 15 6.44772 15 7V17C15 17.5523 14.5523 18 14 18H7C6.44772 18 6 17.5523 6 17V7Z"
			fill="#EE46BC"
		/>
		<path d="M15 10L18 8V16L15 14V10Z" fill="#F670C7" />
	</svg>
);

export const GenericFileIcon: FC<SVGProps<SVGSVGElement>> = ({ className, ...props }) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className} {...props}>
		<rect width="24" height="24" rx="6" fill="#F2F4F7" />
		<path
			d="M6.5 5.5H13L17.5 10V18.5C17.5 19.0523 17.0523 19.5 16.5 19.5H7.5C6.94772 19.5 6.5 19.0523 6.5 18.5V5.5Z"
			fill="#475467"
		/>
		<path d="M13 5.5V10H17.5" fill="#667085" />
		<line x1="9" y1="13.5" x2="15" y2="13.5" stroke="#FFFFFF" strokeWidth="1" strokeLinecap="round" />
		<line x1="9" y1="15.5" x2="13" y2="15.5" stroke="#FFFFFF" strokeWidth="1" strokeLinecap="round" />
	</svg>
);

export const CategoryFileIcon: FC<{ category: AttachmentCategory; className?: string }> = ({ category, className }) => {
	switch (category) {
		case 'pdf':
			return <PdfFileIcon className={className} />;
		case 'doc':
			return <WordFileIcon className={className} />;
		case 'excel':
			return <ExcelFileIcon className={className} />;
		case 'image':
			return <ImageFileIcon className={className} />;
		case 'video':
			return <VideoFileIcon className={className} />;
		case 'text':
		case 'file':
		default:
			return <GenericFileIcon className={className} />;
	}
};
